
import React, { Component } from 'react';
import {Drawer} from 'ui/Drawer';
import OrderDetail  from 'components/Order/Detail';

import styled from 'styled-components';
import {DateTimeDisplay} from 'core/Display';

const StyledOrderListItem = styled.div`
  min-width: 0;
  
  .order-link {
    display: inline-flex;
    align-items: center;
    padding: 0 6px;
    height: 18px;
    border-radius: 999px;
    background: #fff;
    border: 1px solid #f0c94a;
    color: #2F80ED;
    font-weight: 600;
    font-size: 13px;
    cursor: pointer;
    white-space: nowrap;
  }
  
  .points {
    margin-top: 3px;
    font-size: 11px;
    line-height: 1.25;
    color: #555;
  }
  
  .time {
    color: #828282;
  }
  
  .client {
    margin-top: 2px;
    font-size: 11px;
    color: #333;
  }
`;


export default class OrderListItem extends Component {

  constructor(props) {
    super(props);

    this.state = {
      isDrawerOpen: false
    };
  }

  openPreview = () => {
    const { order, onPreview } = this.props;
    if (onPreview) {
      onPreview(order);
      return;
    }
    this.setState({ isDrawerOpen: true });
  };

  closePreview = () => {
    this.setState({ isDrawerOpen: false });
  };

  render() {
    const { order, onPreview, previewId, compact } = this.props;
    const isPreviewOpen = previewId !== undefined && String(previewId) === String(order.id);
    const isDrawerOpen = isPreviewOpen || this.state.isDrawerOpen;
    const points = order.points || [];

    return (
      <StyledOrderListItem>

        <span onClick={this.openPreview} className={'order-link'}>Перевозка #{order.id}</span>

        {!compact && points.length > 0 && (
          <div className={'points'}>
            {points.map((point, index) =>
              <span key={point.id}>
                {point.point_name}
                {point.date && (
                  <span className={'time'}>{' '}(<DateTimeDisplay value={point.date} />)</span>
                )}
                {index + 1 !== points.length && ' – '}
              </span>
            )}
          </div>
        )}

        {!compact && order.client_name && (
          <div className={'client'}><strong>{order.client_name}</strong></div>
        )}

        {!onPreview && (
          <Drawer
            open={isDrawerOpen}
            onClose={this.closePreview}
            width={'450px'}
          >
            <OrderDetail id={order.id} onClose={this.closePreview} />
          </Drawer>
        )}
      </StyledOrderListItem>
    )
  }
}
